import { GameEvents } from '../../GameEvents';
import { CharacterAttack } from './CharacterAttack';

export class AttackRobinSpecialForward extends CharacterAttack {
  checkAttackTargets() {}
  updateAttackCollider() {}
  trigger() {
    super.trigger();
    this.disableAttackCollider();
    this.disableBodyCollider();
  }

  completeAttack() {
    super.completeAttack();
  }

  launchProjectile() {
    this._scene.events.emit(GameEvents.SPAWN_PROJECTILE, {
      sprite: 'projectile_robin',
      damage: this.damage,
      knockdown: this.knockdown,
      x: this.character.x + 150 * this.character.faceDirection,
      y: this.character.y - 130,
      depth: this.character.y,
      velocity: { x: 1500 * this.character.faceDirection, y: 0 },
      isHero: true,
    });
  }
}
